export const averageTruckAgeOptions = [
  { key: "0-3", text: "0–3", value: 1 },
  { key: "4-6", text: "4–6", value: 2 },
  { key: "7-10", text: "7–10", value: 3 },
  { key: "10+", text: "10+", value: 4 },
];

export const euroSpecificationOptions = [
  { key: "euro5", text: "Euro 5", value: 1 },
  { key: "euro6", text: "Euro 6", value: 2 },
  { key: "mixed", text: "Mixed", value: 3 },
];

export const truckTypeOptions = [
  { id: 1, name: "Auto Transport" },
  { id: 4, name: "Enclosed" },
  { id: 5, name: "Other" },
].sort((a, b) => a.name.localeCompare(b.name));

export const trailerBuildTypeOptions = [
  { id: 1, name: "LF1–3" },
  { id: 2, name: "LF4–6" },
  { id: 3, name: "LF7–10" },
  { id: 4, name: "High & Heavy" },
].sort((a, b) => a.name.localeCompare(b.name));

export const driverLanguageOptions = [
  { key: "english", text: "English", value: 1 },
  { key: "german", text: "German", value: 2 },
  { key: "french", text: "French", value: 3 },
  { key: "spanish", text: "Spanish", value: 4 },
  { key: "italian", text: "Italian", value: 5 },
  { key: "dutch", text: "Dutch", value: 6 },
  { key: "polish", text: "Polish", value: 7 },
  { key: "czech", text: "Czech", value: 8 },
  { key: "romanian", text: "Romanian", value: 9 },
  { key: "hungarian", text: "Hungarian", value: 10 },
  { key: "bulgarian", text: "Bulgarian", value: 11 },
  { key: "turkish", text: "Turkish", value: 12 },
  { key: "lithuanian", text: "Lithuanian", value: 13 },
  { key: "latvian", text: "Latvian", value: 14 },
  { key: "estonian", text: "Estonian", value: 15 },
  { key: "ukrainian", text: "Ukrainian", value: 16 },
  { key: "russian", text: "Russian", value: 17 },
  { key: "portuguese", text: "Portuguese", value: 18 }
].sort((a, b) => a.text.localeCompare(b.text));
